import Vue from 'vue'
import confirm from './affirm.vue'

const ConfirmBox = Vue.extend(confirm);

let Confirm = (text, options) => {
  // if (typeof title === 'object') {
  //   options = title;
  //   title = '';
  // } else if (title === undefined) {
  //   title = '';
  // }

  options = Object.assign({
    text
  }, options);

  let instance = new ConfirmBox({
    data: options
  }).$mount();

  document.body.appendChild(instance.$el);

  return instance.confirm();
};

export default Confirm;
